export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/more-icon.svg?8d6baef8ffbb2a52fbd89039a9b2e8ab";